import styled from 'styled-components';
import HorseRacing from '../../../common/components/js/sports/HorseRacing';

interface IProps {
  gradePickup: {
    isShow: boolean;
    races?: Array<{
      grade: string;
      date: string;
      raceNum: string;
      url: string;
      raceTitle: string;
      status: string;
    }>;
  };

  hasTitle: boolean; // モジュールタイトルを表示する
}
const HorseRacingWrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.news.palette.bor_lv1_pc};
`;

const TopHorseRacing: React.FC<IProps> = props => {
  if (!props.gradePickup.isShow) {
    return null;
  }
  return (
    <HorseRacingWrapper>
      <HorseRacing gradePickup={props.gradePickup} hasTitle={props.hasTitle} />
    </HorseRacingWrapper>
  );
};

export default TopHorseRacing;
